import { HStack } from '@starrez/starryui9';
import React, { ReactNode } from 'react';
import { strings } from '../../../.localisation';
import { SearchInput } from '../../../.starryUI/SearchInput/SearchInput';
import { ClearFilterButton } from './ClearFilterButton';

export interface IButtonBarProps {
    children?: ReactNode;
    OnFilterSearchChange: (change: FilterChange) => void;
}

export type FilterChange = { type: 'Clear' } | { type: 'Search'; searchString: string };

export const ButtonBar = ({ children, OnFilterSearchChange }: IButtonBarProps) => {
    const handleClearFilters = () => {
        OnFilterSearchChange({ type: 'Clear' });
    };

    const handleSearchChange = (searchString: string) => {
        return new Promise<void>((resolve) => {
            OnFilterSearchChange({ type: 'Search', searchString });
            resolve();
        });
    };

    return (
        <HStack gap="xxSmall" align="center" justifyContent="end" sizing="max-content">
            <ClearFilterButton disabled={false} onClick={handleClearFilters} />
            {children}
            <SearchInput
                onSearchChange={handleSearchChange}
                placeholder={strings.Label_Search}
                searchAriaLabel={strings.Label_Search}
                clearAriaLabel={strings.ClearSearch}
            />
        </HStack>
    );
};
